const namespace = 'str/songs/';

const songsActionNames = {
  GET_SONG: `${namespace}GET_SONG`,
  GET_SONG_SUCCESS: `${namespace}GET_SONG_SUCCESS`,
  GET_SONGS: `${namespace}GET_SONGS`,
  GET_SONGS_SUCCESS: `${namespace}GET_SONGS_SUCCESS`,
  RESET_SONGS: `${namespace}RESET_SONGS`,
  SET_SONG_LIST_POSITION: `${namespace}SET_SONG_LIST_POSITION`,
  GET_RECOMMENDED_SONGS: `${namespace}GET_RECOMMENDED_SONGS`,
  GET_RECOMMENDED_SONGS_SUCCESS: `${namespace}GET_RECOMMENDED_SONGS_SUCCESS`,
  RESET_RECOMMENDED_SONGS: `${namespace}RESET_RECOMMENDED_SONGS`,
};
export default songsActionNames;
